import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import {
  DownloadOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;
const Kpidriverreport = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [driverList, setDriverList] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const formRef = useRef();

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    driver_id: "",
    status: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      const queryParamsObject = {
        ...state,
        start_date: startDate || null,
        end_date: endDate || null,

        driver_id: stateFilter?.driver_id || null,

        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      // const payload = {
      //   zone_id: stateFilter?.zone_id || [],
      //   suburb_id: stateFilter?.suburb_id || [],
      // };

      try {
        const apiResponse = await getRequest(
          // `return-driver-report/driver-report-filter/?${queryParams}`,
          `kpi-report/kpi-count-report/?${queryParams}`
        );
        if (apiResponse.data.success) {
          setEmployeeList(apiResponse.data.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error fetching employee list"));
      } finally {
        setLoading(false);
      }
    };

    getEmployeeList();
  }, [state, t]);
  //}, [state, t, startDate, endDate, stateFilter?.driver_id]); // Include missing dependencies

  const [checkedList, setCheckedList] = useState([
    "driver_id",
    "failed_count",
    "in_transit_count",
    "packages",
    "loaded_count",
    "package_count",
    // "driver__name",
    "delivered_count",
    // "rd_return_to_depo",
    // "rts_return_to_sender",
    "received_in_depo_count",
    "not_scanned_count",
  ]);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const updatedColumns = [
      // Define columns here

      {
        title: "Driver",
        dataIndex: "driver_name",
        key: "driver_id",
        sorter: true,
        width: 100,
      },

      // {
      //   title: "Packages",
      //   dataIndex: "packages",
      //   key: "packages",
      //   sorter: true,
      //   width: 200,
      //   //render: (packages) => packages.join(", "), // If you want to list package IDs
      //   render: (packages) =>
      //     packages.map((packageItem) => packageItem.id).join(", "),
      // },

      {
        title: "Total Package",
        dataIndex: "package_count",
        key: "package_count",
        sorter: true,
        width: 100,
      },

      {
        title: "Not Scanned",
        dataIndex: "not_scanned_count",
        key: "not_scanned_count",
        sorter: true,
        width: 100,
      },
      {
        title: "Received in Depo",
        dataIndex: "received_in_depo_count",
        key: "received_in_depo_count",
        sorter: true,
        width: 100,
      },
      {
        title: "Loaded By Driver",
        dataIndex: "loaded_count",
        key: "loaded_count",
        sorter: true,
        width: 100,
      },
      {
        title: "In Transit",
        dataIndex: "in_transit_count",
        key: "in_transit_count",
        sorter: true,
        width: 100,
      },
      {
        title: "Delivered",
        dataIndex: "delivered_count",
        key: "delivered_count",
        sorter: true,
        width: 100,
      },
      {
        title: "Failed Delivery",
        dataIndex: "failed_count",
        key: "failed_count",
        sorter: true,
        width: 100,
      },

      //{
      //   title: "RTS- Return to Sender",
      //   dataIndex: "rts_return_to_sender",
      //   key: "rts_return_to_sender",
      //   sorter: true,
      //   width: 100,
      // },
      // {
      //   title: "RD- Return to depo",
      //   dataIndex: "rd_return_to_depo",
      //   key: "rd_return_to_depo",
      //   sorter: true,
      //   width: 100,
      // },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList, driverList, t]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="driver_id">Driver</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="package_count">Total Package</Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="loaded_count">Loaded By Driver</Checkbox>
            </Col>

            <Col span={12}>
              <Checkbox value="delivered_count">Delivered</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="failed_count"> Failed Delivery</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="in_transit_count">In Transit</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="not_scanned_count">Not Scanned</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="received_in_depo_count">
                Received in Depo
              </Checkbox>
            </Col>
            {/* <Col span={12}>
              <Checkbox value="in_transit_count">
                RTS- Return to Sender
              </Checkbox>
            </Col> */}
            {/* <Col span={12}>
              <Checkbox value="in_transit_count">RD- Return to depo</Checkbox>
            </Col> */}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const getDeliveryStatus = async () => {
      try {
        const response = await getRequest("employee/drivers-list/");
        const { data } = response.data;

        setDriverList(data);
        formRef.current.setFieldsValue(response.data.data);
      } catch (error) {
        // setapiLoading(false);
      }
    };
    getDeliveryStatus();
  }, [state, t]);

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };

  // const handleDeliveryStatus = (value) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     status: value,
  //   }));
  // };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields(); // Reset the driver form fields
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "package_count" && sortOrder === "ascend") {
      sortingEnumKey = "package_count";
    }
    if (sortField === "package_count" && sortOrder === "descend") {
      sortingEnumKey = "-package_count";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }

    if (sortField === "packages" && sortOrder === "ascend") {
      sortingEnumKey = "packages";
    }
    if (sortField === "packages" && sortOrder === "descend") {
      sortingEnumKey = "-packages";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }

    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }

    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "driver__name" && sortOrder === "ascend") {
      sortingEnumKey = "driver__name";
    }
    if (sortField === "driver__name" && sortOrder === "descend") {
      sortingEnumKey = "-driver__name";
    }
    if (sortField === "driver__delivery_charge" && sortOrder === "ascend") {
      sortingEnumKey = "driver__delivery_charge";
    }
    if (sortField === "driver__delivery_charge" && sortOrder === "descend") {
      sortingEnumKey = "-driver__delivery_charge";
    }
    if (sortField === "driver_id" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "driver_id" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }
    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }
    // if (sortField === "rd_return_to_depo" && sortOrder === "ascend") {
    //   sortingEnumKey = "rd_return_to_depo";
    // }
    // if (sortField === "rd_return_to_depo" && sortOrder === "descend") {
    //   sortingEnumKey = "-rd_return_to_depo";
    // }
    // if (sortField === "rts_return_to_sender" && sortOrder === "ascend") {
    //   sortingEnumKey = "rts_return_to_sender";
    // }
    // if (sortField === "rts_return_to_sender" && sortOrder === "descend") {
    //   sortingEnumKey = "-rts_return_to_sender";
    // }
    if (sortField === "received_in_depo_count" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__received_in_depo_count";
    }
    if (sortField === "received_in_depo_count" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__received_in_depo_count";
    }
    if (sortField === "not_scanned_count" && sortOrder === "ascend") {
      sortingEnumKey = "not_scanned_count";
    }
    if (sortField === "not_scanned_count" && sortOrder === "descend") {
      sortingEnumKey = "-not_scanned_count";
    }

    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };

  const minEndDate = startDate
    ? moment(startDate, "DD-MM-YYYY").startOf("day")
    : null;

  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });
    setStartDate(null);
    setEndDate(null);

    formRef.current.setFieldsValue({
      state: undefined,
      zone: undefined,
      suburb: undefined,
      start_date: undefined,
      end_date: undefined,
      status: undefined,
      driver_id: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  //   const downloadCSV = async () => {
  //     const endpoint = `kpi-report/kpi-count-report-excel/

  // `;
  //     const fileType = "csv";

  //     try {
  //       await getRequest(endpoint).then((response) => {
  //         const blob = new Blob([response.data], {
  //           type: "text/csv",
  //         });
  //         const link = document.createElement("a");
  //         link.href = window.URL.createObjectURL(blob);
  //         link.download = `KPIDriverReport${+new Date()}.${fileType}`;
  //         link.click();
  //       });
  //     } catch (error) {
  //       if (error.response && error.response.status === 404) {
  //         console.error("File not found or endpoint is incorrect.");
  //       } else {
  //         console.error("Error downloading the file:", error);
  //       }
  //     }
  //   };

  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `kpi-report/kpi-count-report-excel/`;
    const fileType = "csv";

    // Construct query parameters similar to getEmployeeList
    const queryParamsObject = {
      // ...state,
      start_date: startDate || null,
      end_date: endDate || null,
      driver_id: stateFilter?.driver_id || null,
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    try {
      // Use getRequest with the constructed query parameters
      const response = await getRequest(`${endpoint}?${queryParams}`);

      // Process the response to download the CSV file
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `KPIDriverReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };

  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("KPI Driver Report")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("KPI Driver Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="customdropdwn"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef} layout="vertical">
                <Space wrap
                      size={[16, 10]}>
                 
                    <Form.Item
                      name="start_date"
                      label={t("pl_min_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_start_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("statr_date")}
                      />
                    </Form.Item>
                 
                    <Form.Item
                      name="end_date"
                      label={t("pl_max_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_end_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleEndDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("end_date")}
                        disabled={!startDate}
                        disabledDate={(current) =>
                          current && (minEndDate ? current < minEndDate : false)
                        }
                      />
                    </Form.Item>
                 
                    <Form.Item name="driver_id" label={t("pl_driver")}>
                      <Select
                        placeholder={t("pl_assign_driver")}
                        showArrow
                        showSearch
                        style={{ width: "170px" }}
                        name="driver_id"
                        optionFilterProp="children"
                        onChange={(value) => handleDriverFilter(value)}
                      >
                        {driverList?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                 

                  {/* <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name="status"
                        label={t("delivery_status")}
                        value={state?.status}
                      >
                        <Select
                          showArrow
                          placeholder={t("pl_delivery_status")}
                          onChange={(value) => handleDeliveryStatus(value)}
                        >
                          {/* <Option key="Not Scanned" value="Not Scanned">
                            Not Scanned
                          </Option>
                          <Option key="Received in Depo" value="Received in Depo">
                            Received in Depo
                          </Option>
                          <Option key="Loaded" value="Loaded">
                            Loaded
                          </Option> */}
                  {/* <Option key="Delivered" value="Delivered">
                            Delivered
                          </Option> */}
                  {/* <Option key="Failed" value="Failed">
                            Failed
                          </Option> */}
                  {/* <Option
                            key="RTS- Return to Sender"
                            value="RTS- Return to Sender"
                          >
                            RTS- Return to Sender
                          </Option>
                          <Option
                            key="RD- Return to depo"
                            value="RD- Return to depo"
                          >
                            RD- Return to depo
                          </Option> */}
                  {/* </Select> */}
                  {/* </Form.Item> */}
                  {/* </Col> */}
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {startDate ||
                  endDate ||
                  stateFilter?.status ||
                  stateFilter?.driver_id ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
<div className="tablewrp">
          <Table
            scroll={{ x: 1000 }}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={employeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
        </div>
        </div>
      </section>
      </div>
    </>
  );
};
export default Kpidriverreport;
